import { useTheme } from "@material-ui/core";
import { Hexagon } from ".";

// Displays one tally of either the correct or incorrect answers
const TaskResultCountSingle = ({children, isSuccess}) => {
    const theme = useTheme();

    const color = isSuccess ? theme.palette.teal : theme.palette.pink;

    return (
        <div className={`team-score__result-count team-score__result-count--${isSuccess ? "success" : "failure"}`}>

            <div className={`hexagon task-markers__task task-markers__task--${isSuccess ? "success" : "failure"}`}>
                <Hexagon 
                    fill={color}
                    stroke={color}
                    strokeWidth={2}
                >
                    <i className={`fas fa-${isSuccess ? "check" : "times"}`}></i>
                </Hexagon>
            </div>

            <div className="team-score__count team-score__count">
                {children}
            </div>
        </div>
    )
}

// Displays tallys of right and wrong answers in hexagons
export const TaskResultCount = ({ roundScore }) => {

    const getScoreCount = (correct) => {

        let count = roundScore.reduce((count, taskResult) => {
        
            if (taskResult === correct) {
                count++;
            }
            return count;
        }, 0)

        return count;
    }

    return (
        <>
            <TaskResultCountSingle isSuccess={true}>{getScoreCount(true)}</TaskResultCountSingle>
            <TaskResultCountSingle isSuccess={false}>{getScoreCount(false)}</TaskResultCountSingle>
        </>
    )


}